import { useTranslation } from "react-i18next";
import LoadingSpinner from "@/components/atomic/Loading";
import Progress from "@/components/atomic/Progress";
import { useMessageCostSummary } from "@/hooks/useMessageCostSummary";

export const MessageCostProgress = () => {
  const { t } = useTranslation("voiceek_ui");
  const { data, isLoading, error } = useMessageCostSummary();

  // ローディング中
  if (isLoading) {
    return (
      <div className="rounded-sm bg-[#50608B] px-3 flex items-center">
        <LoadingSpinner />
      </div>
    );
  }

  // エラーまたはデータなし
  if (error || !data) return null;

  const displayUsedPoints = data.usedPoints.toFixed(1);

  // 無制限プランの場合
  if (data.isLimitInfinite()) {
    return (
      <div className="rounded-sm bg-[#50608B] text-white p-2 items-center flex flex-col justify-center">
        <div className="flex items-baseline gap-1">
          <span>{t("chat.messageCost.label")}</span>
          <span className="font-semibold text-lg">{displayUsedPoints}</span>
          <span className="text-sm">Pt</span>
        </div>
      </div>
    );
  }

  // 制限ありプランの場合
  const limit = data.pointLimit!; // isLimitInfinite()がfalseなので、nullではない
  const percent = data.calculateUsagePercentage();

  return (
    <div className="rounded-sm bg-[#50608B] text-white pt-1 px-2 pb-2 items-center flex flex-col justify-center gap-2">
      <div className="flex items-baseline gap-1">
        <span>{t("chat.messageCost.label")}</span>
        <span className="font-semibold text-lg">{displayUsedPoints}</span>
        <span className="text-sm">/ {limit} Pt</span>
      </div>
      <Progress value={percent} className="h-[8px] bg-[#293D72]" />
    </div>
  );
};
